var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudFunctions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#669df6;}.cls-2{fill:#4285f4;}.cls-3{fill:#aecbfa;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_Functions_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "colored-32/functions"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2 15.56 5 18 5 6 2 8.43 2 15.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2 10 5 8 5 6 2 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5 18 5 16 2 14 5 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "8 20 2 14 2 18 6 22 8 20"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5.99 2.01 2 6 2.01 10 7.99 4.01 5.99 2.01"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "colored-32/functions"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22 8.45 19 6.01 19 18.01 22 15.59 22 8.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22 14.01 19 16.01 19 18.01 22 14.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "19 6.01 19 8.01 22 10.01 19 6.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16 4.01 22 10.01 22 6.01 18 2.01 16 4.01"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.01 22 22 18.01 21.99 14.01 16.01 20 18.01 22"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-3",
    cx: 8,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    className: "cls-3",
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    "data-name": "Oval",
    className: "cls-3",
    cx: 15.99,
    cy: 12,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFunctions);
export default __webpack_public_path__ + "static/media/cloud_functions.35d5aacf8e441f0bcfcbc623b1135a37.svg";
export { ForwardRef as ReactComponent };